<template>
  <div class="computer-content">
    <div class="image-box">
      <img v-if="computer.vip_rank > 0" src='/static/images/bgImg-pro.svg' class='bgImg'/>
      <img v-else class="bgImg" src="/static/images/bgImg.png">
    </div>
    <div class="content">
      <div class="binding-top-container">
        <div class="binding-top">
          <img :class="[computer.vip_rank > 0 ? 'vip-avatar' : '']"
               :src="computer.avatar_url == null ? '/static/images/avatar.svg' : computer.avatar_url">
          <img v-if="computer.vip_rank > 0" class="ic-pro" src="/static/images/ic-pro.png"/>
        </div>
        <div style="font-size: 18px;">{{ computer.nick_name }}的电脑信息</div>
        <div class="flex-warp collect-text">
          <div class="avatars flex-warp">
            <template v-for="(item,index) in avatarList">
              <img v-if="index < 5"
                   :class="[
                       'avatarsImg'
                      ,  endS ? 'l200' : ''
                      || startS ? 'l100' : ''
                      || index == 1 ? 'step1' : ''
                      || index == 2 ? 'step2' : ''
                      || index == 3 ? 'step3' : ''
                      || index == 4 ? 'step4' : '']
                   "
                   :src='item.url'/>
            </template>
          </div>
          <div>{{ count }}人已收藏</div>
        </div>
      </div>
      <div class="body">
        <div class="main-info">
          <div class="content-top">
            <div class="top">
              <div class="top-list1">{{ sameData.cpu ? sameData.cpu.same_configuration : 0 }}</div>
              <div class="top-list2">同款CPU</div>
            </div>
            <div class="top">
              <div class="top-list1">{{ sameData.baseboard ? sameData.baseboard.same_configuration : 0 }}</div>
              <div class="top-list2">同款主板</div>
            </div>
            <div class="top">
              <div class="top-list1">{{ sameData.videocontroller ? sameData.videocontroller.same_configuration : 0 }}
              </div>
              <div class="top-list2">同款显卡</div>
            </div>
          </div>
          <div style="height: 1px; background-color: #D8D8D8; margin: 30px 0;"></div>

          <div class='other-status'>
            <div class='float-left'>CPU</div>
            <div class='float-right'>{{ computer.cpu_name }}</div>
          </div>
          <div class='other-status'>
            <div class='float-left'>主板</div>
            <div class='float-right'>{{ computer.baseboard }}</div>
          </div>
          <div class='other-status' style="margin-bottom: 0;">
            <div class='float-left'>内存</div>
            <div class='float-right'>{{ physical_memory }}</div>
          </div>
          <div class="flex-warp flex-row memory">
            <div style="width: 70px; height: 33px;"></div>

            <div class="flex-1 flex-warp flex-dir">
              <div class="flex-1" v-for='(item) in hardware.physicalmemory'>
                <div class="high-light grey">{{ item.manufacturer }} DDR{{ item.ddr }} {{ item.speed }}MHZ</div>
              </div>
            </div>
          </div>
          <div class='other-status' v-if="hardware.diskdrive && hardware.diskdrive.length > 0">
            <div class='float-left'>硬盘</div>
            <div class='float-right' v-for='(item) in hardware.diskdrive'>{{ item.model }}</div>
          </div>
          <div class='other-status'>
            <div class='float-left'>显卡</div>
            <div class='float-right'>{{ computer.main_videocontroller }}</div>
          </div>

          <div class='other-status' v-if="hardware.sounddevice && hardware.sounddevice.length > 0">
            <div class='float-left'>声卡</div>
            <div class='float-right' v-for='(item,index) in hardware.sounddevice' :key='index'>{{ item.name }}</div>
          </div>
          <div class='other-status' v-if="hardware.networkadapter && hardware.networkadapter.length > 0">
            <div class='float-left'>网卡</div>
            <div class='float-right' v-for='(item,index) in hardware.networkadapter' :key='index'>{{ item.name }}</div>
          </div>
          <div class='other-status'>
            <div class='float-left'>系统</div>
            <div class='float-right'>{{ computer.os }} {{ computer.os_bit }}</div>
          </div>
          <div class='other-status' v-if="baseVersion">
            <div class='float-left'>系统版本</div>
            <div class='float-right'>{{ baseVersion }}{{patchVersion > 0 ? '.'+patchVersion : ''}}</div>
          </div>
          <div class='other-status' v-if="computer.newxitong_version">
            <div class='float-left'>吻妻版本</div>
            <div class='float-right'>{{ computer.newxitong_version }}</div>
          </div>
          <div class='other-status'>
            <div class='float-left'>安装日期</div>
            <div class='float-right'>{{ resetTime }}</div>
          </div>
        </div>
        <!--底部-->
        <div class="footer">
          <div class="footer-left">
            <div class="image-container">
              <img mode="widthFix" src="/static/images/hipc.png"/>
            </div>
            <div class="left-from">来自HiPC小程序</div>
          </div>
          <div class="footer-right">生成日期：{{ computer.last_time }}</div>
        </div>

        <!-- 按钮 -->
        <div class="new-button">
          <div class='function-btn btn' @click="jump()">了解HiPC</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {getShareHardware, getFavoritesCount, getSameConfiguration} from '@/api/hardware'
import * as util from '../../utils/util'
import * as tool from '../../utils/tool'

export default {
  name: 'share-computer',
  data () {
    return {
      encryption_key: null,
      id: '11',
      collect: false,
      extend_options:
        {
          cpu: 0,
          physicalmemory: 0,
          temperature: 0
        },
      resetTime: '',
      physical_memory: '',
      computer: {},
      hardware: {},
      sameData: {},
      checkCon: true,
      avatarUrl: '',
      avatarList: [{
        url: '/static/images/avatar1.svg'
      }, {
        url: '/static/images/avatar2.svg'
      }, {
        url: '/static/images/avatar3.svg'
      }, {
        url: '/static/images/avatar4.svg'
      }, {
        url: '/static/images/avatar5.svg'
      }, {
        url: '/static/images/avatar6.svg'
      }],
      startS: false, // 初始动漫开始
      endS: false, // 动漫结束以后把样式放到最右边
      count: 0, // 收藏数
      baseVersion: '',  //内部版本号
      patchVersion: ''  //补丁号
    }
  },
  created () {
    const url = window.location.href;
    // 使用正则表达式截取目标段落
    this.encryption_key = url.match(/\/pc\/(.+)/)[1].split('_')[0];
    this.onLoad()
    this.avatarSroll()
    this.favoritesCount()
    this.sameConfiguration()
  },
  methods: {
    onLoad () {
      getShareHardware(this.encryption_key).then(res => {
        //console.log(res)
        if (res.code == 100 && res.data) {
          // 硬件复制
          let hardware = JSON.parse('{}')

          hardware.diskdrive = JSON.parse(res.data.diskdrive)
          //replaceHardDiskName
          if (hardware.diskdrive && hardware.diskdrive.length > 0) {
            //硬盘
            hardware.diskdrive = hardware.diskdrive.reverse()
            for (var index in hardware.diskdrive) {
              var model = hardware.diskdrive[index].model
              model = util.replaceHardDiskName(model)
              hardware.diskdrive[index].model = model
            }

          }

          hardware.physicalmemory = JSON.parse(res.data.physical_memory)
          //内存
          if (hardware.physicalmemory && hardware.physicalmemory.length > 0) {
            hardware.physicalmemory = hardware.physicalmemory.reverse()
            for (var index in hardware.physicalmemory) {
              var manufacturer = hardware.physicalmemory[index].manufacturer
              var speed = hardware.physicalmemory[index].speed
              manufacturer = util.replacePhysicalmemoryName(manufacturer)
              hardware.physicalmemory[index].ddr = util.physicalmemoryDDR(speed)
              hardware.physicalmemory[index].manufacturer = manufacturer
            }

          }

          //声卡
          hardware.sounddevice = JSON.parse(res.data.sounddevice)
          if (hardware.sounddevice && hardware.sounddevice.length > 0) hardware.sounddevice = hardware.sounddevice.reverse()

          //网卡
          hardware.networkadapter = JSON.parse(res.data.networkadapter)
          if (hardware.networkadapter && hardware.networkadapter.length > 0) hardware.networkadapter = hardware.networkadapter.reverse()
          //物理内存转换
          let physical_memory = res.data.physical_memory_size
          physical_memory = this.convertMemory(physical_memory)

          //常规转换
          res.data.cpu_name = util.replaceCpuName(res.data.cpu_name)
          res.data.baseboard = util.replaceBoardName(res.data.baseboard)
          res.data.main_videocontroller = util.replaceVideocontrollerName(res.data.main_videocontroller)
          let resetTime = tool.formatDate('yy.mm.dd', res.data.system_resetline)

          //windows版本
          if (res.data.os_version) {
            let os_version = res.data.os_version
            let versionList = os_version.split('.')
            // console.log('split', versionList)
            if (versionList.length == 3) {
              this.baseVersion = versionList[2]
              this.patchVersion = ''
            }
            if (versionList.length == 4) {
              this.baseVersion = versionList[2]
              this.patchVersion = versionList[3]
            }
          }
          //头像
          if (!res.data.avatar_url) {
            res.data.avatar_url = '/static/images/avatar.svg'
          }
          if (!res.data.nick_name) {
            res.data.nick_name = 'HiPC'
          }
          res.data.last_time = tool.formatDate('yy.mm.dd', res.data.last_time)

          //赋值
          this.physical_memory = physical_memory
          this.computer = res.data
          this.hardware = hardware
          this.resetTime = resetTime
          document.title = this.computer.nick_name + '的电脑信息'
        } else {
          alert(res.message)
        }
      })
    },

    favoritesCount () {
      getFavoritesCount(this.encryption_key).then(res => {
        if (res.code == 100) {
          this.count = res.data.count
        }
      })
    },

    //同款
    sameConfiguration () {
      getSameConfiguration(this.encryption_key).then(res => {
        //console.log('1', res)
        if (res.code == 100) {
          this.sameData = res.data
        }
      })
    },
    //内存转换
    convertMemory (memory, types = 0) {

      let units = types === 1 ? 'M' : ' MB'
      let units2 = types === 1 ? 'G' : ' GB'

      let newMemory = memory
      if (newMemory < 1024) {
        newMemory = newMemory + units
      } else {
        newMemory = (newMemory / 1024).toFixed(1) + units2
      }
      return newMemory
    },
    avatarSroll () {
      var that = this
      setInterval(function () {
        that.startS = true
        setTimeout(function () { // 执行完以后然后开始把数组前几个放到最后面
          that.startS = false
          that.endS = true
          let arr = that.avatarList
          let arrb = []
          let arrc = []
          for (let i = 0; i < arr.length; i++) {
            if (i < 5) {
              arrb.push(arr[i])
            } else {
              arrc.push(arr[i])
            }
          }
          for (let i = 0; i < arrb.length; i++) {
            arrc.push(arrb[i])
          }
          that.avatarList = arrc
        }, 1000)
        setTimeout(function () { //最后清除所有状态,返回初始状态
          that.endS = false
        }, 1000)
      }, 6500)
    },
    //去官网
    jump () {
      // window.open('https://hipc.cn/','_blank');
      window.location.href = 'https://hipc.cn/'
    },
  }
}
</script>

<style scoped>

body {
  line-height: 1.5 !important;
}

.image-box {
  width: 100%;
}

.body {
  padding-bottom: 70px;
}

.computer-content {

}

.image-box .bgImg {
  width: 100%;
  max-width: 400px;
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.content {
  width: 100%;
  max-width: 400px;
  padding: 0 15px;
  box-sizing: border-box;
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 0;
  z-index: 10;
}

.content .btn {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.header {
  width: 100%;
  height: 32px;
  margin-bottom: 16px;
  display: flex;
}

.header .box-image {
  /* width: 52%; */
  line-height: 32px;
}

.header .box-image .logo {
  width: 84px;
  height: 32px;
}

.logo-text {
  color: #fff;
  font-size: 30px;

}

.body {
  width: 100%;
}

.body .main-info {
  width: 100%;
  padding: 30px 15px 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  /* box-shadow:0px 2px 10px 0px rgba(184,192,204,0.4); */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.main-info .content-top {
  height: 55px;
  /* display: flex;
  justify-content: space-around;
  align-items: center;
  flex-flow: row nowrap;
  margin-left: -40rpx; */
}

.content-top .top {
  height: 55px;
  width: 33.3333%;
  float: left;
}

.content-top .top .top-list1 {
  font-size: 32px;
  font-weight: 700;
  color: #313233;
  text-align: center;
  margin: 0 0 10px;
}

.content-top .top .top-list2 {
  font-size: 14px;
  color: #939599;
  text-align: center;
}


::-webkit-scrollbar {
  display: none;
}

.body .other-status {
  font-size: 14px;
  color: #939599;
  margin: 5px 0;
  overflow: hidden;

}

.body .other-status .float-left {
  float: left;
  width: 70px;
  margin: 4px 0;
}

.body .other-status .float-right {
  float: right;
  width: calc(100% - 70px);
  color: #313233;
  margin: 4px 0;
}


.body .mg-bottom-none {
  margin-bottom: 0;
}

.main-info .middle-top {
  margin: 20px 0px 0px;
  font-size: 18px;
  color: #313233;
  display: flex;
}


.other-status .float-right-add {
  margin-top: -2px;
}

.other-status .float-right {
  color: #939599 !important;
}

.other-status .float-right .weui-badge {
  display: inline-block;
  padding: .13em .4em .15em;
  min-width: 8px;
  border-radius: 18px;
  background-color: #C4C7CC;
  color: #FFFFFF;
  line-height: 1.2;
  text-align: center;
  font-size: 12px;
  vertical-align: middle;
}

.body .other-status .update {
  background: #ff4480;
}

.body .function-btn2 {
  width: 590px;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  text-align: center;
  margin: 50px auto 0px;
  border-radius: 100px;
  color: #313233;
  border: 1px solid #C4C7CC;
}


/* 头部 */

.binding-container .binding-top-container {
  margin: 15% auto 23%;
  text-align: center;
}

.binding-top-container div {
  text-align: center;
  margin-top: 10px;
  color: #fff;
}

.binding-top-container .binding-top {
  height: 60px;
  width: 60px;
  margin: 0px auto 16px;
  position: relative;
}

.binding-top img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.vip-avatar {
  border: 1px solid #FFEFC2;
}


/* 重命名弹窗 */

.detail-frame {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
}

.rename, .unbind {
  width: calc(100% - 40px);
  position: fixed;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  z-index: 110;
  padding: 30px 20px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 10px 0px rgba(184, 192, 204, 0.4);
  /* box-shadow: 0 0 8px #B8C0CC; */
}

.rename .rename-title {
  font-weight: bold;
}

.rename .btn-special {
  box-sizing: border-box;
}

.rename .tips {
  margin-top: 10px;
  font-size: 14px;
  color: #313233;
}

/* 解绑提示 */

.unbind {
  text-align: center;
  padding: 30px 0 0;
}

.unbind .unbind-title {
  font-weight: bold;
}

.unbind .unbind-tips {
  color: #7e7e80;
  padding: 20px 0;
}

.unbind .unbind-btnbox {
  height: 50px;
  line-height: 50px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ececee;
}

.unbind .unbind-btnbox view {
  /* font-size: 14px; */
  width: 50%;
}

.unbind .unbind-btnbox .unbind-confirm {
  color: #36b920;
  border-left: 1px solid #ececee;
}

/* 关机弹出框 */

.detail-frame {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
}

.rename, .restart {
  width: calc(100% - 40px);
  position: fixed;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  z-index: 110;
  padding: 30px 20px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 10px 0px rgba(184, 192, 204, 0.4);
  /* box-shadow: 0 0 8px #B8C0CC; */
}

.rename-title {
  font-weight: bold;
}

.tips {
  margin: 20px 0;
  font-size: 14px;
  color: #313233;
}

.share-container {
  position: fixed;
  right: 60px;
  bottom: 60px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1)
}

.share-container .share-image {
  width: 120px;
  height: 120px;
}

/* footer部分 */

.footer {
  position: unset !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row nowrap;
}

.footer .footer-left {
  height: 24px;
  font-size: 14px;
  color: #313233;
  display: flex;
  align-items: center;
}

.footer-left .image-container {
  width: 20px;
  height: 20px;
  display: inline-block;
  float: left;
}

.image-container img {
  width: 100%;
  height: 100%;
}

.image-container .left-from {
  display: inline-block;
}

.footer-left .left-from {
  float: left;
  margin-left: 3px;
  font-size: 14px;
}

.footer-right {
  font-size: 12px;
  color: #939599;
}

/* 按钮 */
.new-button {
  padding: 20px 10px 0;
}

.cancle-btn {
  margin-top: 12px;
}

/* 头像组 */
.binding-top-container view.collect-text {
  font-size: 14px;
  margin-bottom: 20px;
  justify-content: center;
}

.binding-top-container view.avatars {
  margin-bottom: 0;
  margin-right: 6px;
  overflow: hidden;
}

.memory .flex-warp {
  display: flex;
  width: 100%;
  align-items: flex-start;
}

.flex-dir {
  flex-direction: column;
}

.flex-1 {
  flex: 1;
}

.high-light.grey {
  background: #B8C0CC;
}

.high-light {
  display: inline-block;
  height: 18px;
  line-height: 18px;
  border-radius: 50px;
  color: #fff;
  font-size: 10px;
  text-align: center;
  padding: 0 10px;
  margin: 2px 0;

}


.avatarsImg {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  border: 1px solid #fff;
  margin-left: -10px;
  transition: all 1s ease;
  position: relative;
  left: 0;
  background-color: #fff;
  z-index: 0;
}

.avatars img:first-child {
  margin-left: 0;
}

.step1 {
  transition-delay: .5s;
  left: -2px;
  z-index: 1
}

.step2 {
  transition-delay: 1s;
  left: -2px;
  z-index: 2;
}

.step3 {
  transition-delay: 1.5s;
  left: -2px;
  z-index: 2;
}

.step4 {
  transition-delay: 2s;
  left: -2px;
  z-index: 2;
}

.l100 {
  left: -100px;
}

.l200 {
  transition: all 0s ease;
  left: 200px;
}

.image-box {
  width: 100%;
}

.image-box .bgImg {
  width: 100%;
  display: block;

}

.binding-top-container {
  text-align: center;
  margin-bottom: 10px;
  color: #fff;

}

.binding-top-container .collect-text {
  font-size: 14px;
  margin-bottom: 20px;
  justify-content: center;

}

.flex-warp {
  display: flex;
  align-items: center;

}

.binding-top-container .avatars {
  margin-bottom: 0;
  margin-right: 6px;
  overflow: hidden;

}

.function-btn {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #3385ff;
  color: #fff;
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
  border-radius: 50px;
}

.ic-pro {
  position: absolute;
  bottom: -5px;
  left: 15px;
  width: 30px !important;
  height: 15px !important;
  border-radius: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/view/hipc/ShareComputer.vue